import type { IPrompt } from '@/src/types/app.type'

type ClientPrompt = string | IPrompt

/**
 * Only the text-assistant UI reads the prompt in the browser.
 * Other room types must not receive it in Next.js page props.
 */
export const getClientPromptProps = (
  roomType: string | null | undefined,
  prompt: ClientPrompt,
): { prompt?: ClientPrompt } => (roomType === 'textAssistant' ? { prompt } : {})
